import {CircleX} from "lucide-react";
import {useNavigate, useParams} from "react-router-dom";
import {Fragment, useEffect, useState} from "react";
import PaymentInformationAPI from "~/api/paymentInformationApi";
import {format} from "date-fns";

function PaymentFail() {
    const navigate = useNavigate();
    const [paymentInfo, setPaymentInfo] = useState(null);
    const { id } = useParams();
    useEffect(function () {
        PaymentInformationAPI.paymentFail(id)
            .then(res => {
                if(res.data?.Succeeded == false){
                    navigate("/auth/error/404", { replace: true });
                    return;
                }
                else {
                    setPaymentInfo(res.data);
                }
            })
    }, []);

    return (
        <Fragment>
        {
            paymentInfo &&
            (
                <div className="text-center pt-10">
                    <CircleX size={30} className="text-danger"/>
                    <h4 className="mt-2 fw-semibold">Payment Failed</h4>

                    <p className="fs-8-1 mt-7">
                        ❌ <strong>Transaction unsuccessful.</strong><br/>
                        No charges have been made to your account.
                    </p>

                    <div className="d-flex justify-content-center">
                        <div className="w-50">
                            <ul className="list-group list-group-flush text-start mb-4">
                                <li className="list-group-item d-flex justify-content-between">
                                    <span className="text-muted">Reason</span>
                                    <strong>{paymentInfo.ErrorDescription}</strong>
                                </li>
                                <li className="list-group-item d-flex justify-content-between">
                                    <span className="text-muted">Transaction ID</span>
                                    <strong>{paymentInfo.PaymentIntentId}</strong>
                                </li>
                                <li className="list-group-item d-flex justify-content-between">
                                    <span className="text-muted">Date</span>
                                    <strong>{format(new Date(paymentInfo.CreatedAt), "dd-MM-yyyy hh:mm:ss a")}</strong>
                                </li>
                            </ul>

                            <div className="d-grid gap-2">
                                <a href="/Home" className="btn btn-primary fw-semibold">
                                    Back To Home Page
                                </a>
                            </div>

                            <p className="text-muted small mt-3">
                                For any information, please contact us via&nbsp;
                                <a href="tel:949 287-8439" className="fw-semibold text-decoration-none">
                                    phone: (949) 287-8439
                                </a>
                                &nbsp;or&nbsp;
                                <a href="mailto:paideia@breakthrough.chat" className="fw-semibold text-decoration-none">
                                    email: paideia@breakthrough.chat
                                </a>.
                            </p>
                        </div>
                    </div>
                </div>
            )
        }
        </Fragment>
    )
}

export default PaymentFail;